var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3zm8 7.764v2.696c0 .298-.194.54-.432.54H.432C.194 14 0 13.758 0 13.46v-2.696c0-1.004.313-1.949.88-2.66C1.45 7.393 2.203 7.002 3.008 7h.054l.047.034A3.255 3.255 0 005 7.659a3.25 3.25 0 001.89-.625L6.939 7h.054c.803 0 1.559.393 2.128 1.104.567.711.88 1.656.88 2.66z",
    fill: "#333"
  })));
};

export default SvgUserIcon;